import { useEffect } from "react";
import { Hub } from "aws-amplify";
import { useDispatch, useSelector } from 'react-redux';
import { useOrderSubscription } from './hooks/useOrderSubscription';
import Admin from "./layouts/Admin";
import { API } from "@aws-amplify/api";
import { Provider } from "react-redux";
import { Auth } from "@aws-amplify/auth";
import { Amplify } from "@aws-amplify/core";
import { store } from "./internals/app/Store";
import { Storage } from "@aws-amplify/storage";
import { Actions } from "./internals/app/Actions";
import InviteModal from "./components/InviteModal";
import OtpView from "./modules/login/views/OtpView";
import UserView from "./modules/user/views/UserView";
import MenuView from "./modules/menu/views/MenuView";
import awsconfig from "./internals/config/aws_config";
import BrandView from "./modules/brand/views/BrandView";
import TableView from "./modules/table/views/TableView";
import OfferView from "./modules/offer/views/OfferView";
import StockIntakeListView from "./modules/stock/views/StockIntakeListView";
import SignInView from "./modules/login/views/SignInView";
import SignUpView from "./modules/login/views/SignUpView";
import ProductView from "./modules/product/views/Product";
import ReportView from "./modules/report/views/ReportView";
import RewardView from "./modules/reward/views/RewardView";
import PasswordView from "./modules/login/views/PasswordView";
import ServiceView from "./modules/service/views/ServiceView";
import BusinessView from "./modules/login/views/BusinessView";
import CompanyInfo from "./modules/setting/views/CompanyInfo";
import PersonalInfo from "./modules/setting/views/PersonalInfo";
import RegisterInfo from "./modules/setting/views/RegisterInfo";
import Subscription from "./modules/setting/views/Subscription";
import CustomerView from "./modules/customer/views/CustomerView";
import CategoryView from "./modules/category/views/CategoryView";
import SupplierView from "./modules/supplier/views/SupplierView";
import EmployeeView from "./modules/employee/views/EmployeeView";
import DownloadView from "./modules/download/views/DownloadView";
import DiscountView from "./modules/discount/views/DiscountView";
import ModifierView from "./modules/modifier/views/ModifierView";
import WarrantyView from "./modules/warranty/views/WarrantyView";
import MixpanelService from "./internals/service/MixpanelService";
import DashboardView from "./modules/dashboard/views/DashboardView";
import PaymentLoading from "./modules/setting/views/PaymentLoading";
import { RouterProvider, createBrowserRouter, Navigate } from "react-router-dom";
import StockIntakeEditorView from "./modules/stock/views/StockIntakeEditorView";
import StockLevelsView from "./modules/stockLevels/views/StockLevelsView";
import SubscriptionPlans from "./modules/setting/views/SubscriptionPlans";
import UberEatsInfo from "./modules/setting/views/UberEatsInfo";
import CompReportView from "./modules/complementary/views/CompReportView";
import ContactsView from "./modules/complementary/views/ContactsView";
import TransactionView from "./modules/transaction/views/TransactionView";
import InvoiceListView from "./modules/invoice/views/InvoiceListView";
import InvoiceEditorView from "./modules/invoice/views/InvoiceEditorView";
import InvoiceDetailView from "./modules/invoice/views/InvoiceDetailView";
import InvoiceSettingsView from "./modules/invoice/views/InvoiceSettingsView";
import InvoiceApprovalsView from "./modules/invoice/views/ApprovalsView";
import SignUpSubscription from "./modules/login/views/SignUpSubscription";
import CloseCashDetails from "./modules/transaction/views/CloseCashDetails";
import CourseView from "./modules/course/views/CourseView";
import MembersView from "./modules/netlyPay/views/MembersView";
import ImportMembersView from "./modules/netlyPay/views/ImportMembersView";
import PaymentRequestsView from "./modules/netlyPay/views/PaymentRequestsView";
import ApprovalsView from "./modules/netlyPay/views/ApprovalsView";
import NetlyPaySettingsView from "./modules/netlyPay/views/NetlyPaySettingsView";
// import AddCourseView from "./modules/course/views/AddCourseView";

API.configure(awsconfig);
Auth.configure(awsconfig);
Amplify.configure(awsconfig);
Storage.configure(awsconfig);

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Admin />,
    children: [
      {
        path: "/dashboard",
        element: <DashboardView />,
      },
      {
        path: "/product",
        element: <ProductView />,
      },
      {
        path: "/menu",
        element: <MenuView />,
      },
      {
        path: "/category",
        element: <CategoryView />,
      },
      {
        path: "/brand",
        element: <BrandView />,
      },
      {
        path: "/supplier",
        element: <SupplierView />,
      },
      {
        path: "/service",
        element: <ServiceView />,
      },
      {
        path: "/courses",
        element: <CourseView />,
      },
      // {
      //   path: "/courses/add",
      //   element: <AddCourseView />,
      // },
      {
        path: "/customers",
        element: <CustomerView />,
      },
      {
        // Netly Pay. routes.ts lists it for the sidebar; this is the one that
        // actually renders it — /stock-levels 404'd for a week because only
        // the first was done. routeWiring.test.ts now checks the pair.
        path: "/members",
        element: <MembersView />,
      },
      {
        path: "/members/import",
        element: <ImportMembersView />,
      },
      {
        path: "/payment-requests",
        element: <PaymentRequestsView />,
      },
      {
        path: "/approvals",
        element: <ApprovalsView />,
      },
      {
        path: "/netly-pay/settings",
        element: <NetlyPaySettingsView />,
      },
      {
        path: "/employees",
        element: <EmployeeView />,
      },
      {
        path: "/report",
        element: <ReportView />,
      },
      {
        path: "/transaction",
        element: <TransactionView />,
      },
      {
        // The Transaction tab that listed POS receipts was called "Invoices";
        // it is now "Receipts" and real invoices live under /invoices.
        path: "/receipts",
        element: <Navigate to="/transaction" replace />,
      },
      {
        path: "/invoices",
        element: <InvoiceListView />,
      },
      {
        path: "/invoices/new",
        element: <InvoiceEditorView />,
      },
      {
        // Before /invoices/:docId so "approvals" is never read as a docId.
        path: "/invoices/approvals",
        element: <InvoiceApprovalsView />,
      },
      {
        path: "/invoices/:docId",
        element: <InvoiceDetailView />,
      },
      {
        path: "/invoices/:docId/edit",
        element: <InvoiceEditorView />,
      },
      {
        path: "/settings/invoicing",
        element: <InvoiceSettingsView />,
      },
      {
        path: "/personal-info",
        element: <PersonalInfo />,
      },
      {
        path: "/company-info",
        element: <CompanyInfo />,
      },
      {
        path: "/register-info",
        element: <RegisterInfo />,
      },
      {
        path: "/subscription-plans",
        element: <SubscriptionPlans />,
      },
      {
        path: "/integrations",
        element: <UberEatsInfo />,
      },
      {
        path: "/complementary",
        element: <Navigate to="/complementary/report" replace />,
      },
      {
        path: "/complementary/report",
        element: <CompReportView />,
      },
      {
        path: "/complementary/contacts",
        element: <ContactsView />,
      },
      {
        path: "/subscription",
        element: <Subscription />,
      },
      {
        path: "/admin/recurring-loading",
        element: <PaymentLoading />,
      },
      {
        path: "/reward",
        element: <RewardView />,
      },
      {
        path: "/discounts",
        element: <DiscountView />,
      },
      {
        path: "/modifiers",
        element: <ModifierView />,
      },
      {
        path: "/stock",
        element: <StockIntakeListView />,
      },
      {
        path: "/stock/intake/:intakeId",
        element: <StockIntakeEditorView />,
      },
      {
        // The legacy purchase screen. Anything bookmarked there lands on the
        // intakes list rather than a 404.
        path: "/purchase-stock",
        element: <Navigate to="/stock" replace />,
      },
      {
        path: "/stock-levels",
        element: <StockLevelsView />,
      },
      {
        path: "/warranty",
        element: <WarrantyView />,
      },
      {
        path: "/offer",
        element: <OfferView />,
      },
      {
        path: "/close-cash",
        element: <CloseCashDetails />,
      },
      {
        path: "/tables",
        element: <TableView />,
      },
      {
        path: "/download",
        element: <DownloadView />,
      },
      {
        path: "/users",
        element: <UserView />,
      },
    ],
  },
  {
    path: "/signup-subscription",
    element: <SignUpSubscription />,
  },
  {
    path: "/signin",
    element: <SignInView />,
  },
  {
    path: "/signup",
    element: <SignUpView />,
  },
  {
    path: "/forget-password",
    element: <PasswordView />,
  },
  {
    path: "/business-manage",
    element: <BusinessView />,
  },
  {
    path: "/otp-screen",
    element: <OtpView />,
  },
]);
const unsubscribe = Hub.listen("auth", ({ payload: { event, data }}) => {
  console.log({event, data})
  switch (event) {
    case "signIn":
      // setUser(data);
      break;
    case "signOut":
      // setUser(null);
      break;
    case "customOAuthState":
      // setCustomState(data);
  }
});
/**
 * Inner component rendered inside the Redux Provider so that
 * useDispatch / useSelector are available.
 */
const AppSubscriptions = () => {
  const dispatch = useDispatch();
  const selectedShop = useSelector((state: any) => state.dashboard.get('selectedShop'));
  useOrderSubscription(selectedShop?.shopId, dispatch);
  return null;
};

const App = () => {

  useEffect(() => {
    // console.log('App auth')
    MixpanelService.init();
    // const unsubscribe = Hub.listen("auth", ({ payload: { event, data }}) => {
    //   console.log({event, data})
    //   switch (event) {
    //     case "signIn":
    //       // setUser(data);
    //       break;
    //     case "signOut":
    //       // setUser(null);
    //       break;
    //     case "customOAuthState":
    //       // setCustomState(data);
    //   }
    // });

    // getUser();

    return unsubscribe;
  }, []);
  
  return (
    <Provider store={store}>
      <AppSubscriptions />
      <InviteModal />
      <RouterProvider router={router} />
    </Provider>
  );
};
export default App;
store.dispatch(Actions.login.authenticatedUser());
